// extracted by mini-css-extract-plugin
module.exports = {"select":"Select-module__select___3EQJ3"};